module.exports = require("ramda/src/length");